import { useQuery } from 'urql';
import { GET_LATEST_LOAN_DOCS, GET_OWNERSHIP, GET_OWNERSHIPS, GET_OWNERSHIPS_BY_CREATOR, GET_OWNERSHIPS_BY_ENTITY } from './graphql';
import { GetOwnershipQuery, GetOwnershipsByCreatorQuery, GetOwnershipsByCreatorQueryVariables, GetOwnershipsByEntityQuery, GetOwnershipsByEntityQueryVariables, QueryGetLatestLoanDocsArgs, QueryGetOwnershipByIdArgs, QueryGetOwnershipsByEntityArgs } from 'gql/graphql';
import { UseQueryInterface } from 'utils/interfaces/use-query.interface';

export const useGetOwnerships = (query?: any) => {
  const [{ data, fetching, error }] = useQuery({ query: query || GET_OWNERSHIPS });
  return { data: data?.GetOwnerships, fetching, error };
}

export const useGetOwnershipsByEntity = (vars: UseQueryInterface<QueryGetOwnershipsByEntityArgs>) => {
    const [{ data, ...others }, execute] = useQuery<GetOwnershipsByEntityQuery>({
        query: vars?.query || GET_OWNERSHIPS_BY_ENTITY,
        ...vars
      });
      return {
        data: data?.GetOwnershipsByEntity,
        execute: (data?: GetOwnershipsByEntityQueryVariables) => execute({ GetOwnershipsByEntity: data }),
        ...others
      };
}

export const useGetOwnershipsByCreator = (vars: UseQueryInterface<any>) => {
  const [{ data, ...others }, execute] = useQuery<GetOwnershipsByCreatorQuery>({
      query: vars?.query || GET_OWNERSHIPS_BY_CREATOR,
      ...vars
    });
    return {
      data: data?.GetOwnershipsByCreator,
      execute: (data?: GetOwnershipsByCreatorQueryVariables) => execute({ GetOwnershipsByCreator: data }),
      ...others
    };
}

export const useGetOwnership = (
  vars?: UseQueryInterface<QueryGetOwnershipByIdArgs>
) => {
  const [{ data, ...others }, reexecute] = useQuery<GetOwnershipQuery>({
    query: vars?.query || GET_OWNERSHIP,
    ...vars
  });
  return {
    data: data?.GetOwnershipById,
    reexecute,
    ...others
  };
};

export const useGetLatestLoanDocs = (
  vars?: UseQueryInterface<QueryGetLatestLoanDocsArgs>
) => {
  const [{ data, ...others }, reexecute] = useQuery<any>({
    query: vars?.query || GET_LATEST_LOAN_DOCS,
    ...vars
  });
  return {
    data: data?.GetLatestLoanDocs,
    reexecute,
    ...others
  }
}
